<div class="bg-th-blue mt-0 container-fluid py-2 position-sticky top-0 index-3">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer"></i>

        <p class="text-white f18 my-auto dirI d-flex align-items-center"> داشبورد جامع </p>

    </div>

</div>


<!-- جزییات ناوگان به تفکیک هر خط -->

<p class="fw-bold text-center bg-blue-light py-2"> جزییات ناوگان به تفکیک هر خط  </p>

<div echarts [autoResize]="true" [options]="options | async" id="totalVehicles" class="tree-chart border-bottom"></div>

<!-- جدول ها -->

<div class="d-flex justify-content-around flex-wrap mt-4" style="direction: rtl;">

    <!-- کارآمد ترین ناوگان در ماه گذشته -->
    
    <div class="col-12 rounded shadow mb-5 px-2">

        <div class="py-4">

            <p class="text-center f18"> کارآمد ترین ناوگان در ماه گذشته </p>

            <div style="height: 380px !important;">

                <div class="mt-3 p-2">

                    <div class="section border border-2 mt-2" style="max-height: 350px;overflow: auto;">

                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                            <thead>

                                <tr class="">

                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center"> کد خط </th>

                                    <th class="text-center"> نام خط </th>

                                    <th class="text-center"> نام و نام خانوادگی </th>

                                    <th class="text-center"> کارایی </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="col-12 text-center" *ngFor="let item of lst_BestTaxies;let i = index">

                                    <td> {{ i + 1 | faNum }}</td>

                                    <td> {{ item.strBusLineCode | faNum }}</td>

                                    <td> {{ item.strBusLineName | faNum }}</td>

                                    <td> {{ item.strFullName | faNum }}</td>

                                    <td> {{ item.fADT | faNum }}</td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    </div>

    <!-- کم کار ترین ناوگان در ماه گذشته -->
    
    <div class="col-12 rounded shadow mb-5 px-2">

        <div class="py-4">

            <p class="text-center f18"> کم کار ترین ناوگان در ماه گذشته </p>

            <div style="height: 380px !important;">

                <div class="mt-3 p-2">

                    <div class="section border border-2 mt-2" style="max-height: 350px;overflow: auto;">

                        <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                            <thead>

                                <tr class="">

                                    <th class="text-center col-1"> # </th>

                                    <th class="text-center"> کد خط </th>

                                    <th class="text-center"> نام خط </th>

                                    <th class="text-center"> نام و نام خانوادگی </th>

                                    <th class="text-center"> کارایی </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="col-12 text-center" *ngFor="let item of lst_BadTaxies;let i = index">

                                    <td> {{ i + 1 | faNum }}</td>

                                    <td> {{ item.strBusLineCode | faNum }}</td>

                                    <td> {{ item.strBusLineName | faNum }}</td>

                                    <td> {{ item.strFullName | faNum }}</td>

                                    <td> {{ item.fADT | faNum }}</td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>

<!-- وضعیت سن ناوگان -->

<p class="sticky-top fw-bold text-center bg-blue-light py-2"> وضعیت سن ناوگان </p>

<div echarts [autoResize]="true" [options]="options1 | async" id="orgVehiclesStatus" class="tree-chart border-bottom"></div>